function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.3103 15.2341L16.7855 14.8669C17.7471 13.4512 18.2553 11.7898 18.2553 10.0635C18.2553 5.3901 14.5086 1.58798 9.90299 1.58798C8.35055 1.58798 6.83542 2.02312 5.52148 2.84651L5.18638 2.29586C6.60107 1.40971 8.23226 0.940918 9.90299 0.940918C14.86 0.940918 18.893 5.03324 18.893 10.0635C18.893 11.9218 18.3459 13.71 17.3103 15.2341ZM9.90305 19.1855C4.94604 19.1855 0.913025 15.0935 0.913025 10.0633C0.913025 8.25831 1.43178 6.51287 2.41317 5.01622L2.94404 5.37469C2.03247 6.76458 1.55071 8.38611 1.55071 10.0633C1.55071 14.7367 5.29772 18.5385 9.90305 18.5385C11.6474 18.5385 13.3178 17.9988 14.7348 16.9774L15.104 17.5051C13.579 18.6045 11.7804 19.1855 9.90305 19.1855ZM18.0654 18.8032C18.1276 18.8663 18.2092 18.898 18.2909 18.898C18.3725 18.898 18.4541 18.8663 18.5163 18.8032C18.641 18.6767 18.641 18.4722 18.5163 18.3457L1.74081 1.32356C1.61614 1.19706 1.41431 1.19706 1.28996 1.32356C1.1653 1.44973 1.1653 1.65453 1.28996 1.78103L18.0654 18.8032Z",
  fill: "#6E6E6E"
});

var SvgNoAnswer = function SvgNoAnswer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoAnswer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-answer.87c1793a.svg";
export { ForwardRef as ReactComponent };